<template>
  <div>
    <v-container
        style="max-width: unset; background: #e5e5e5"
    >
      <v-card
          transition="scale-transition"
          class="d-column mt-0 mb-4 py-1"
          elevation="1"
          color="#FFFFFF"
          style="border-radius: 6px"
      >
        <v-row class="pt-3  pb-2 ma-0 justify-space-between">
          <v-col
              cols="12"
              sm="6"
              md="4"
              lg="4"
              class="pa-2"
          >
            <v-autocomplete
                v-model="filter.resaleIds"
                multiple
                outlined
                item-text="name"
                item-value="id"
                hide-details="auto"
                placeholder="Selecione o revendedor"
                label="Revendedor"
                menu-props="auto"
                :items="resales"
            ></v-autocomplete>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="4"
              lg="4"
              class="pa-2"
          >
            <v-autocomplete
                v-model="filter.usersIds"
                multiple
                outlined
                item-text="name"
                item-value="id"
                hide-details="auto"
                placeholder="Selecione o usuário"
                label="Usuário"
                menu-props="auto"
                :items="users"
            ></v-autocomplete>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="4"
              lg="4"
              class="pa-2"
          >
            <v-text-field
                v-model="filter.action"
                outlined
                placeholder="Digite a ação"
                label="Ação"
                hide-details="auto"
            ></v-text-field>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="4"
              lg="4"
              class="pa-2"
          >
            <v-text-field
                v-model="filter.startDate"
                outlined
                placeholder="Data de início"
                label="Data de início"
                type="date"
            ></v-text-field>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="4"
              lg="4"
              class="px-2"
              style="margin-top: -2px;"
          >
            <v-text-field
                v-model="filter.endDate"
                outlined
                placeholder="Data de fim"
                label="Data de fim"
                type="date"
            ></v-text-field>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="4"
              lg="4"
              class="px-2 d-flex justify-space-between"
              style="margin-top: -2px; "
          >
            <v-btn
                outlined
                width="31%"
                style="border-radius: 8px!important;"
                large
                @click="searchForResellerStockHistory"
            >
              Buscar
            </v-btn>

            <v-btn
                outlined
                width="31%"
                style="border-radius: 8px!important;"
                large
                dense
                @click="reset"
            >
              Limpar
            </v-btn>

            <v-btn
                outlined
                width="31%"
                style="border-radius: 8px!important;"
                large
                @click="excel"
            >
              Exportar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-data-table
          :headers="headers"
          :items="logs"
          class="content-table"
          loading-text="Buscando..."
          no-data-text="Sem registros"
          hide-default-footer
      >
        <template v-slot:[`item.resale`]="{ item }">
          {{ item.resale && item.resale.name ? item.resale.name : '-' }}
        </template>

        <template v-slot:[`item.user`]="{ item }">
          {{ item.user && item.user.name ? item.user.name : '-' }}
        </template>

        <template v-slot:[`item.createdAt`]="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>

        <template v-slot:footer class="ma-0 pa-0">
          <section class="ma-0 pa-0">
            <Pagination
                v-if="totalItems > filter.pageSize"
                :currentPage="currentPage"
                :totalItems="totalItems"
                :page="filter.page"
                :pageSize="filter.pageSize"
                :totalPages="totalPages"
                @back-page="backPage"
                @next-page="nextPage"
            >
            </Pagination>
          </section>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script lang="js">
import ApiService from '../../../services/ApiService';
import Utils from "@/Utils/FormatDate";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "Logs",
  components: {Pagination},

  created() {
  },

  async mounted() {
    try {
      await this.list()
      await this.getResales()
      await this.getUser()
    } catch (e) {

    }
  },

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      filters: false,
      activeTab: 0,
      currentPage: 1,
      totalPages: 1,
      totalItems: 1,
      filter: {
        action: '',
        resaleIds: [],
        usersIds: [],
        startDate: null,
        endDate: null,
        page: 1,
        totalPages: 1,
        pageSize: 15,
      },
      headers: [
        {
          text: "Usuário",
          value: "user",
          sortable: false,
        },
        {
          text: "Revenda",
          value: "resale",
          sortable: false,
        },
        {
          text: "Ação",
          value: "action",
          sortable: false,
        },
        {
          text: "Data",
          value: "createdAt",
          sortable: false,
        },
      ],
      items: [],
      logs: [],
      resales: [],
      users: [],
      userTypes: [0, 2, 3, 5, 6, 7, 8],
    }
  },

  methods: {
    formatDate(date) {
      return Utils.moment(date);
    },

    getResales() {
      this.apiService.get("resale/list").then((response) => {
        this.resales = response;
      });
    },

    getUser() {
      this.apiService.post(`user/list-all`, {types: this.userTypes}).then((response) => {
        this.users = response;
      });
    },

    reset() {
      this.filter = {
        action: '',
        resaleIds: [],
        startDate: null,
        endDate: null,
        usersIds: [],
        page: 1,
        pageSize: 15,
      }
      this.list()
    },

    excel() {
      this.loading = true;
      this.apiService
          .post("log/excel",{...this.filter})
          .then((response) => {
            const excel ="data:application/octet-stream;base64," + response.content;
            const link = document.createElement("a");
            link.href = excel;
            link.setAttribute("download", `logs.xlsx`);
            document.body.appendChild(link);
            link.click();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },

    async searchForResellerStockHistory() {
      await this.list()
    },

    async list() {
      this.loading = true;
      this.apiService.post('log/list', this.filter).then((response) => {
        this.logs = response.logs
        this.totalPages = response.pager.totalPages
        this.currentPage = response.pager.currentPage
        this.totalItems = response.pager.totalItems
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },

    async backPage() {
      this.filter.page -= 1;
      await this.list();
    },

    async nextPage() {
      this.filter.page += 1;
      await this.list();
    },
  },

  watch: {}
};
</script>

<style scoped>
.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}

.tab {
  font-weight: bold;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

</style>
